function togglePasswordVisibility(toggleButton) {
  if (!toggleButton) return;

  var controlId = toggleButton.getAttribute("aria-controls");
  var passwordInput = controlId ? document.getElementById(controlId) : null;
  var icon = toggleButton.querySelector("img");

  if (!passwordInput || !icon) return;

  var isHidden = passwordInput.type === "password";
  passwordInput.type = isHidden ? "text" : "password";
  toggleButton.setAttribute("aria-pressed", isHidden ? "true" : "false");
  toggleButton.setAttribute("aria-label", isHidden ? "Hide password" : "Show password");
  icon.src = isHidden ? "//ringconn.com/cdn/shop/t/270/assets/view.svg?v=93999776838137558691792466874" : "//ringconn.com/cdn/shop/t/270/assets/hidden.svg?v=79978484582135763311792466818";
}

function preparePasswordToggle(toggleButton) {
  if (!toggleButton || toggleButton.hasAttribute("data-password-toggle-bound")) return;

  toggleButton.setAttribute("data-password-toggle-bound", "true");

  if (toggleButton.tabIndex < 0) {
    toggleButton.tabIndex = 0;
  }

  toggleButton.addEventListener("click", function () {
    togglePasswordVisibility(toggleButton);
  });

  toggleButton.addEventListener("keydown", function (event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    togglePasswordVisibility(toggleButton);
  });
}

function initPasswordToggles(root) {
  var scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll("[data-password-toggle]").forEach(preparePasswordToggle);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function () {
    initPasswordToggles(document);
  });
} else {
  initPasswordToggles(document);
}

document.addEventListener("shopify:section:load", function (event) {
  initPasswordToggles(event.target);
});
